import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fullScreen : false
  },
  mutations: {
    goFullScreen(state){
      state.fullScreen = true
    },
    exitFullScreen(state){
      state.fullScreen = false
    },
  },
  actions: {
  },
  modules: {
  }
})
